export default "__VITE_ASSET__CLyLwOdN__"